// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
    width: 60rem;
    height: 35rem;
    background-color: var(--secondary-bg-color);
    border: 2px solid var(--border-color);
    border-radius: 1rem;
    display: grid;
    grid-template-rows: 0.5fr 1fr 1fr 1fr 1fr;
    grid-template-columns: repeat(12, 1fr);
    padding: 1rem;
    row-gap: 1rem;
    column-gap: 2rem;
}

.app__title {
    grid-row: 1 / 2;
    grid-column: 1 / 7;
    margin: 0;
    align-self: center;
    color: var(--primary-text-color);
    font-family: var(--display-font);
}

.app__search {
    grid: 1/2;
    grid-column: 7 / -1;
    align-self: center;
    justify-self: self-end;
    border: 1px solid var(--border-color);
    padding: 0.2rem 0.3rem;
    width: 70%;
    height: 45px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 5rem;
    background-color: var(--tertiary-bg-color);

}

.app .card__icon svg .cls-3,
.app .card__icon svg .cls-4,
.app .card__icon svg .cls-5 {
    stroke: white;
}

.app__searchBox {
    border: none;
    width: 80%;
    height: 100%;
    border-radius: 5rem;
    background-color: var(--tertiary-bg-color);
    font-family: var(--primary-font);
    font-size: 1.02rem;
}

.app__searchBox:focus {
    outline: none;
}

.app__searchBox:valid {
    background-color: var(--tertiary-bg-color);
    color: var(--primary-text-color);
    font-family: var(--primary-font);
}

.app__searchBox:-webkit-autofill {
    border: orange;
}

.app__searchBox::placeholder {
    color: var(--secondary-text-color);
}

.app__searchBtn {
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    width: 20%;
    height: 100%;
    border-radius: 5rem;
    background-color: var(--border-color);
    padding: 0;
}

.app__searchBtn>svg {
    stroke: var(--primary-text-color);
}

/* hero card */

.card.hero {
    grid-column: 1/7;
    grid-row: 2/4;
    width: 100%;
    height: 100%;
    border: 1.5px solid var(--border-color);
    padding: 1rem;
    background-color: var(--tertiary-bg-color);
    border-radius: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}

.card__tempContainer {
    height: 65%;
    display: flex;
    gap: 2rem;
    align-items: center;
    justify-content: space-between;
}

.card__temp {
    font-size: 5rem;
}

.card__timezone {
    font-size: 0.9rem;
}

.card__address {
    text-align: right;
    font-size: 1rem;
    width: clamp(10rem, 55%, 300px);
}

.card__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: clamp(1rem, 15%, 2rem);
}

.card__icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40%;
    height: 100%;
}

.card__icon>svg {
    height: 90%;
}

/* trivial cards */

.card__precipitation,
.card__visibility,
.card__uv.index,
.card__winds {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--border-color);
    border-radius: 1rem;
    padding: 0.5rem;
    background-color: var(--tertiary-bg-color);
}

.card__precipitation svg,
.card__visibility svg,
.card__uv.index svg,
.card__winds svg {
    width: 50px;
    height: 50px;
}

.card__precipitation,
.card__visibility {
    grid-column: 7/10;
}

.card__uv.index,
.card__winds {
    grid-column: 10/13;
}

/* days */

.app__days {
    grid-row: 4 / 6;
    grid-column: 1/-1;
    display: grid;
    grid-template-columns: repeat(7, minmax(0, 1fr));
    grid-template-rows: subgrid;
    column-gap: 1rem;
}

.card__day {
    display: flex;
    flex-direction: column;
    grid-row: 1 / 3;
    justify-content: center;
    align-items: center;
    background-color: var(--tertiary-bg-color);
    border: 1px solid var(--border-color);
    border-radius: 1rem;
}

.card__day .card__icon {
    height: 60%;
    width: 50%;
}

.card__day .card__tempsHolder>.card__temp {
    font-size: 1rem;
}

.card__day .day {
    font-size: 1.25rem;
}

.card__tempsHolder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/ui/home.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,qCAAqC;IACrC,mBAAmB;IACnB,aAAa;IACb,yCAAyC;IACzC,sCAAsC;IACtC,aAAa;IACb,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,SAAS;IACT,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,qCAAqC;IACrC,sBAAsB;IACtB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;IACnB,0CAA0C;;AAE9C;;AAEA;;;IAGI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,gCAAgC;AACpC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,mBAAmB;IACnB,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,iCAAiC;AACrC;;AAEA,cAAc;;AAEd;IACI,gBAAgB;IAChB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,aAAa;IACb,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,WAAW;AACf;;AAEA,kBAAkB;;AAElB;;;;IAII,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,mBAAmB;IACnB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;;;;IAII,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;AACtB;;AAEA,SAAS;;AAET;IACI,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,gDAAgD;IAChD,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;IAC1C,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,UAAU;AACd;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB","sourcesContent":[".app {\n    width: 60rem;\n    height: 35rem;\n    background-color: var(--secondary-bg-color);\n    border: 2px solid var(--border-color);\n    border-radius: 1rem;\n    display: grid;\n    grid-template-rows: 0.5fr 1fr 1fr 1fr 1fr;\n    grid-template-columns: repeat(12, 1fr);\n    padding: 1rem;\n    row-gap: 1rem;\n    column-gap: 2rem;\n}\n\n.app__title {\n    grid-row: 1 / 2;\n    grid-column: 1 / 7;\n    margin: 0;\n    align-self: center;\n    color: var(--primary-text-color);\n    font-family: var(--display-font);\n}\n\n.app__search {\n    grid: 1/2;\n    grid-column: 7 / -1;\n    align-self: center;\n    justify-self: self-end;\n    border: 1px solid var(--border-color);\n    padding: 0.2rem 0.3rem;\n    width: 70%;\n    height: 45px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 5rem;\n    background-color: var(--tertiary-bg-color);\n\n}\n\n.app .card__icon svg .cls-3,\n.app .card__icon svg .cls-4,\n.app .card__icon svg .cls-5 {\n    stroke: white;\n}\n\n.app__searchBox {\n    border: none;\n    width: 80%;\n    height: 100%;\n    border-radius: 5rem;\n    background-color: var(--tertiary-bg-color);\n    font-family: var(--primary-font);\n    font-size: 1.02rem;\n}\n\n.app__searchBox:focus {\n    outline: none;\n}\n\n.app__searchBox:valid {\n    background-color: var(--tertiary-bg-color);\n    color: var(--primary-text-color);\n    font-family: var(--primary-font);\n}\n\n.app__searchBox:-webkit-autofill {\n    border: orange;\n}\n\n.app__searchBox::placeholder {\n    color: var(--secondary-text-color);\n}\n\n.app__searchBtn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: none;\n    width: 20%;\n    height: 100%;\n    border-radius: 5rem;\n    background-color: var(--border-color);\n    padding: 0;\n}\n\n.app__searchBtn>svg {\n    stroke: var(--primary-text-color);\n}\n\n/* hero card */\n\n.card.hero {\n    grid-column: 1/7;\n    grid-row: 2/4;\n    width: 100%;\n    height: 100%;\n    border: 1.5px solid var(--border-color);\n    padding: 1rem;\n    background-color: var(--tertiary-bg-color);\n    border-radius: 1rem;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n}\n\n.card__tempContainer {\n    height: 65%;\n    display: flex;\n    gap: 2rem;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.card__temp {\n    font-size: 5rem;\n}\n\n.card__timezone {\n    font-size: 0.9rem;\n}\n\n.card__address {\n    text-align: right;\n    font-size: 1rem;\n    width: clamp(10rem, 55%, 300px);\n}\n\n.card__header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    height: clamp(1rem, 15%, 2rem);\n}\n\n.card__icon {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40%;\n    height: 100%;\n}\n\n.card__icon>svg {\n    height: 90%;\n}\n\n/* trivial cards */\n\n.card__precipitation,\n.card__visibility,\n.card__uv.index,\n.card__winds {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border: 1px solid var(--border-color);\n    border-radius: 1rem;\n    padding: 0.5rem;\n    background-color: var(--tertiary-bg-color);\n}\n\n.card__precipitation svg,\n.card__visibility svg,\n.card__uv.index svg,\n.card__winds svg {\n    width: 50px;\n    height: 50px;\n}\n\n.card__precipitation,\n.card__visibility {\n    grid-column: 7/10;\n}\n\n.card__uv.index,\n.card__winds {\n    grid-column: 10/13;\n}\n\n/* days */\n\n.app__days {\n    grid-row: 4 / 6;\n    grid-column: 1/-1;\n    display: grid;\n    grid-template-columns: repeat(7, minmax(0, 1fr));\n    grid-template-rows: subgrid;\n    column-gap: 1rem;\n}\n\n.card__day {\n    display: flex;\n    flex-direction: column;\n    grid-row: 1 / 3;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--tertiary-bg-color);\n    border: 1px solid var(--border-color);\n    border-radius: 1rem;\n}\n\n.card__day .card__icon {\n    height: 60%;\n    width: 50%;\n}\n\n.card__day .card__tempsHolder>.card__temp {\n    font-size: 1rem;\n}\n\n.card__day .day {\n    font-size: 1.25rem;\n}\n\n.card__tempsHolder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 0.25rem;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
